import mime from 'mime/lite';
import PropTypes from 'prop-types';
import { PureComponent } from 'react';

import FieldFileAdvanced from 'Component/FieldFileAdvanced';
import { CUSTOMER_TYPES } from 'Component/MyAccountCreateAccount/MyAccountCreateAccount.config';
import { CustomerFormValuesType } from 'Type/Account.type';

import { FORM_ID_STRINGS } from './MyAccountConfirmIdForm.config';

import './MyAccountConfirmIdForm.style';

/** @namespace PeggysagePwa/Component/MyAccountConfirmIdForm/Component */
export class MyAccountConfirmIdFormComponent extends PureComponent {
    static propTypes = {
        customerType: PropTypes.string.isRequired,
        fileType: PropTypes.string.isRequired,
        formStrings: PropTypes.objectOf(PropTypes.string).isRequired,
        isSkipDisabled: PropTypes.bool.isRequired,
        isSubmitDisabled: PropTypes.bool.isRequired,
        onSkip: PropTypes.func.isRequired,
        onSubmit: PropTypes.func.isRequired,
        onChangeFile: PropTypes.func.isRequired,
        setRefFieldFile: PropTypes.func.isRequired,
        isFileLoaded: PropTypes.bool.isRequired,
        defaultValues: CustomerFormValuesType.isRequired
    };

    renderDescription() {
        const { fileType, formStrings } = this.props;

        const description = formStrings.description
            || FORM_ID_STRINGS[fileType]?.description
            || FORM_ID_STRINGS.default.description;

        return (
            <div block="MyAccountConfirmIdForm" elem="Description">
                <p>
                    { description }
                    { ' ' }
                    <strong>{ __('Les fichiers transmis sont supprimés après vérification.') }</strong>
                </p>
            </div>
        );
    }

    renderUpload() {
        const {
            fileType, formStrings, onChangeFile, setRefFieldFile, defaultValues
        } = this.props;

        const description = formStrings.uploadDescription
            || FORM_ID_STRINGS[fileType]?.uploadDescription
            || FORM_ID_STRINGS.default.uploadDescription;

        const defaultFile = defaultValues[fileType] || null;
        const file = defaultFile ? {
            name: defaultFile.filename,
            type: mime.getType(defaultFile.filename)
        } : {};
        const fileData = defaultFile ? defaultFile.content : null;

        return (
            <FieldFileAdvanced
              attr={ {
                  name: fileType,
                  id: fileType,
                  accept: 'image/jpg,image/jpeg,image/png,application/pdf'
              } }
              events={ { onChange: onChangeFile } }
              setRef={ setRefFieldFile }
              description={ description }
              file={ file }
              fileData={ fileData }
            />
        );
    }

    renderSkipContent() {
        const {
            fileType, formStrings, isSkipDisabled, onSkip, isFileLoaded, customerType
        } = this.props;

        if (isSkipDisabled || isFileLoaded) {
            return null;
        }

        const warning = formStrings.skipWarning
            || FORM_ID_STRINGS[fileType]?.skipWarning
            || (customerType === CUSTOMER_TYPES.pro && FORM_ID_STRINGS.default.skipWarningPro)
            || (customerType === CUSTOMER_TYPES.student && FORM_ID_STRINGS.default.skipWarningStudent);

        const label = formStrings.skipLabel
            || FORM_ID_STRINGS[fileType]?.skipLabel
            || FORM_ID_STRINGS.default.skipLabel;

        return (
            <div block="MyAccountConfirmIdForm" elem="Skip">
                <button
                  block="Button"
                  type="button"
                  mix={ { block: 'MyAccountConfirmIdForm', elem: 'SkipButton' } }
                  mods={ { likeLink: true } }
                  onClick={ onSkip }
                >
                    { label }
                </button>
                { warning && (
                    <p block="MyAccountConfirmIdForm" elem="SkipWarning">
                        { warning }
                    </p>
                ) }
            </div>
        );
    }

    renderSubmitButton() {
        const { onSubmit, isFileLoaded, isSubmitDisabled } = this.props;

        if (isSubmitDisabled || !isFileLoaded) {
            return null;
        }

        return (
            <div block="MyAccountConfirmIdForm" elem="Buttons">
                <button
                  block="Button"
                  type="button"
                  mix={ { block: 'MyAccountConfirmIdForm', elem: 'SubmitButton' } }
                  onClick={ onSubmit }
                >
                    { __('Continue') }
                </button>
            </div>
        );
    }

    renderContent() {
        return (
            <>
                { this.renderDescription() }
                { this.renderUpload() }
                { this.renderSkipContent() }
                { this.renderSubmitButton() }
            </>
        );
    }

    render() {
        return (
            <div block="MyAccountConfirmIdForm">
                { this.renderContent() }
            </div>
        );
    }
}

export default MyAccountConfirmIdFormComponent;
